// extracted by mini-css-extract-plugin
module.exports = {"smallCookieBanner":"CookieNotice_smallCookieBanner__I4b18","cookieBanner":"CookieNotice_cookieBanner__XrfFs","allCookies":"CookieNotice_allCookies__3rqt2"};